// extracted by mini-css-extract-plugin
export default {"container":"Access_container__-YOY0","wrapper":"Access_wrapper__gMxMj"};